import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = (props) => {
   if (!sessionStorage.getItem('user')) {
      return <Redirect to='login' />;
   } else {
      return <Route {...props} />;
   }
};

export default ProtectedRoute;
